'use client';

import React from 'react';
import AspectRatio from '@/components/layout/AspectRatio';
import { cn } from '@/lib/utils';
import ResponsiveWrapper from '@/components/layout/ResponsiveWrapper';
import Image from '../../image';
import SkeletonImage from '../../parts/SkeletonImage';
import type { ImageWithSkeletonProps } from './types';

function ImageWithSkeleton({
  src,
  alt,
  width,
  height,
  fill = false,
  sizes = '100vw',
  presetRatio,
  responsive = {},
  className = '',
  aspectRatioClassName = '',
  skeletonClassName = '',
  ...props
}: ImageWithSkeletonProps) {
  const [isLoaded, setIsLoaded] = React.useState(false);

  const handleOnLoad = React.useCallback(() => {
    setIsLoaded(prev => prev || true);
  }, []);

  const handleOnError = React.useCallback(() => {
    setIsLoaded(prev => prev || true);
  }, []);

  return (
    <ResponsiveWrapper responsive={responsive}>
      <AspectRatio
        presetRatio={presetRatio}
        className={cn('w-full h-full', aspectRatioClassName)}
      >
        <SkeletonImage isLoaded={isLoaded} className={skeletonClassName}>
          <Image
            src={src}
            alt={alt}
            width={width}
            height={height}
            fill={fill}
            sizes={sizes}
            className={className}
            onLoad={handleOnLoad}
            onError={handleOnError}
            {...props}
          />
        </SkeletonImage>
      </AspectRatio>
    </ResponsiveWrapper>
  );
}

export default React.memo(ImageWithSkeleton);
